module.exports = __webpack_public_path__ + "img/attack of the giants.0431ffe6.png";